/* eslint-disable no-unreachable */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-use-before-define */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Form, message } from "antd";
import { isFunction, uniqBy } from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import "react-phone-number-input/style.css";
import { useSelector, useDispatch } from "react-redux";
import { mergeLeadDetail } from "../../redux/slices/leadSlice";
import { UserContext } from "../../amplify/authenticator-provider";
import { CREATE_LEAD_OPPORTUNITY, UPDATE_LEAD_OPPORTUNITY } from "../../graphql/mutation";
import {
  GET_ALL_USERS,
  GET_CRM_LEAD_STATUS,
  GET_LEAD_DETAIL_CLICK,
  GET_LEAD_SOURCES,
  GET_LEAD_SOURCES_NEW,
} from "../../graphql/query";
import { AccessPermissionAction } from "../../library/constants";
import { checkAccessPermission } from "../../library/helpers";
import { getParentIds } from "../../library/utils";
import { toTitleCase } from "../../utils";
import LeadCustomerInformationForm from "./leadCustomerInformationForm";
import LeadOpportunityInformationForm from "./leadOpportunityInformationForm";
import { sanitizeVehiclesForMutation } from "./vehicleModal/utils/vehiclePayload";

/**
 *
 * @param {{profileForm:import("antd").FormInstance}} props
 * @returns
 */
const LeadEditModal = props => {
  const {
    lead,
    refetch = () => {},
    refetchLeads = () => {},
    getLeads = () => {},
    refetchLeadOpportunities = () => {},
    crmIntegration = "",
    mode = "ADD",
    setSelectedLead,
    setLeadList,
    onClose = () => {},
    showOpportunityForm,
    profileForm,
    form,
    createLead,
    updateLead,
    createLoader,
    updateLoader,
  } = props;
  const { user, setleadIds } = useContext(UserContext);
  const { leads } = useSelector(state => state.lead);

  const [isCrmIntegrated, setIsCrmIntegrated] = useState(!!crmIntegration);
  const [CRMIntegrationType, setCRMIntegrationType] = useState("");

  useEffect(() => {
    setIsCrmIntegrated(!!CRMIntegrationType);
  }, [CRMIntegrationType]);

  const [getAllUsers] = useLazyQuery(GET_ALL_USERS, {
    fetchPolicy: "network-only",
    variables: { companyId: user.company.id, isGlobalLeadOwner: true },
    onCompleted: res => {
      const users = res?.getUsers?.data || [];
      const list = (users || []).map(el => ({
        value: el.id,
        label: `${el.fullName} (${el?.companyRole?.name || "N/A"})`,
      }));
    },
  });

  const handleCrmOppr = () => {};

  useEffect(() => {
    if (isCrmIntegrated) {
      handleCrmOppr();
      getAllUsers();
    }
  }, [lead, crmIntegration, isCrmIntegrated]);
  const { selectedLead, selectedLeadId } = useSelector(state => state.lead);
  const dispatch = useDispatch();
  const [leadStatus, setLeadStatus] = useState(lead?.leadStatusTypeId || "");
  const [address, setAddress] = useState(
    (lead?.addresses?.length > 0 && lead?.addresses[0]?.addressLine1) || ""
  );
  const [city, setCity] = useState((lead?.addresses?.length > 0 && lead?.addresses[0]?.city) || "");
  const [state, setState] = useState(
    (lead?.addresses?.length > 0 && lead?.addresses[0]?.state) || ""
  );
  const [country, setCountry] = useState(
    (lead?.addresses?.length > 0 && lead?.addresses[0]?.country) || "United States"
  );

  const [leadStatusList, setLeadStatusList] = useState([]);

  const [getLeadStatus, { data: CRMData }] = useLazyQuery(GET_CRM_LEAD_STATUS, {
    fetchPolicy: "network-only",
    onCompleted: resp => {
      let list = uniqBy(resp?.getCrmLeadStatus?.data || [], "status").map(e => ({
        text:
          resp?.getCrmLeadStatus?.crmIntegrationType === ""
            ? `${e.type} / ${e?.status.replace(/_/g, " ")}`
            : e?.status.replace(/_/g, " "),
        value: e?.statusTypeId,
      }));
      setCRMIntegrationType(resp?.getCrmLeadStatus?.crmIntegrationType);
      if (lead?.leadStatusTypeId) {
        const index = list.findIndex(item => item.value === lead?.leadStatusTypeId);
        if (index === -1) {
          const obj = resp?.getCrmLeadStatus?.data.find(
            item => item.statusTypeId === lead?.leadStatusTypeId
          );
          list = list.filter(item => item.text !== obj.status);
          list.push({
            text: obj.status.replace(/_/g, " "),
            value: obj.statusTypeId,
          });
        }
      }
      setLeadStatusList(list);
      const findIndex = list.findIndex(el => String(el.value) === String(leadStatus));
      if (findIndex === -1) {
        setLeadStatus("");
      }
    },
  });
  useEffect(() => {
    if (!lead) {
      if (CRMData?.getCrmLeadStatus?.crmIntegrationType === "SF") {
        const obj = leadStatusList.find(item => item.text === "Open");
        setLeadStatus(obj.value);
      } else if (CRMData?.getCrmLeadStatus?.crmIntegrationType === "DS") {
        const obj = leadStatusList.find(item => item.text === "Unqualified");
        setLeadStatus(obj.value);
      } else if (CRMData?.getCrmLeadStatus?.crmIntegrationType === "") {
        const obj = leadStatusList.find(item => item.text.includes("NEW SMAI LEAD"));
        setLeadStatus(obj.value);
      }
    }
  }, [leadStatusList]);

  useMemo(() => {
    getLeadStatus();
  }, [user]);
  const { data: sourcesData, loading: sourceLoader } = useQuery(GET_LEAD_SOURCES, {
    fetchPolicy: "cache-first",
    onCompleted: resp => {
      setSourceList(
        uniqBy(resp.leadSources || [], "name").map(el => ({
          text: el?.name,
          value: el?.id,
          isAddedFromCrm: el?.isAddedFromCrm,
        }))
      );
      if ((resp?.leadSources || []).length > 0) {
        resp?.leadSources.map(_source => {
          // _source.id === String(lead?.leadSource?.id) && setSource(_source.id);
        });
      }
    },
  });
  const [sourceList, setSourceList] = useState([
    { text: lead?.leadSource?.name, value: lead?.leadSource?.id },
  ]);
  const [updateLeadOpportunity, { loading: updateLeadOpportunityLoader }] =
    useMutation(UPDATE_LEAD_OPPORTUNITY);

  const [leadData, setleadData] = useState({
    leadOpportunityUsers: [],
    vehiclesOfInterest: [],
    phones: [],
    emails: [],
  });
  const phoneArr = ["Mobile", "Work", "Home", "Other"];
  const emailTypes = ["PERSONAL", "WORK", "OTHER"];
  const [primaryPhoneType, setprimaryPhoneType] = useState(phoneArr[0]);
  const [primaryEmailType, setprimaryEmailType] = useState(emailTypes[0]);
  const [createLeadOpportunity, { loading: createLeadOpportunityLoader }] =
    useMutation(CREATE_LEAD_OPPORTUNITY);
  const [selectedOpportunity, setselectedOpportunity] = useState({
    leadOpportunityUsers: [],
    vehiclesOfInterest: [],
  });
  const [newOpportunity, setnewOpportunity] = useState(false);
  // const [form] = Form.useForm();
  // const [profileForm] = Form.useForm();
  const [opprtunityForm] = Form.useForm();

  useEffect(() => {
    if (mode === "EDIT") {
      setleadData({
        ...leadData,
        firstName: lead?.firstName,
        lastName: lead?.lastName,
        emails: lead?.emails,
        phones:
          lead?.phoneNumbers?.map(({ potentialLeads, lookupType, ...item }) => ({
            ...item,
            phoneType: toTitleCase(item.phoneType || lookupType),
          })) || [],
        addressLine1:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.addressLine1) || "",
        addressLine2:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.addressLine2) || "",
        city: (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.city) || "",
        state: (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.state) || "",
        postalCode:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.postalCode) || "",
        country:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.country) || "",
      });
      const resultObject = {};
      (lead?.phoneNumbers || []).forEach(item => {
        // Extract lookupType and phone from each item
        const { phoneType, phone, lookupType } = item;

        // Add the phone number to the resultObject with the lookupType as the key
        resultObject[toTitleCase(phoneType || lookupType)] = phone;
      });
      profileForm.setFieldsValue({
        firstName: lead?.firstName,
        lastName: lead?.lastName,
        email: lead?.emails && lead?.emails.length > 0 && lead?.emails[0]?.email,
        phones:
          lead?.phoneNumbers?.map(({ potentialLeads, lookupType, ...item }) => ({
            ...item,
            phoneType: toTitleCase(item.phoneType || lookupType),
          })) || [],
        // phone: lead?.phoneNumbers && lead?.phoneNumbers.length > 0 && lead?.phoneNumbers[0]?.phone,
        addressLine1:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.addressLine1) || "",
        addressLine2:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.addressLine2) || "",
        city: (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.city) || "",
        state: (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.state) || "",
        postalCode:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.postalCode) || "",
        country:
          (lead?.addresses && lead?.addresses.length > 0 && lead?.addresses[0]?.country) || "",
        ...resultObject,
      });
    } else if (mode === "ADD") {
      // Reset leadData state when in ADD mode
      setleadData({
        leadOpportunityUsers: [],
        vehiclesOfInterest: [],
        phones: [],
        emails: [],
      });
      setprimaryPhoneType(phoneArr[0]);
      setprimaryEmailType(emailTypes[0]);
    }
  }, [mode, lead]);

  const handleSaveLead = async value => {
    try {
      if (mode === "EDIT") {
        /* empty */
      } else {
        // Collect additional emails and phones from the form
        const additionalEmails = form.collectAdditionalEmails ? form.collectAdditionalEmails() : [];
        const additionalPhones = form.collectAdditionalPhones ? form.collectAdditionalPhones() : [];

        // Merge existing emails (with "Self" relation) with additional emails
        const allEmails = [
          ...leadData.emails
            .filter(item => item.relationshipType === "Self")
            .map(item => ({
              ...item,
              isPrimary: primaryEmailType === item.emailType,
            })),
          ...additionalEmails,
        ];

        // Merge existing phones (with "Self" relation) with additional phones
        const allPhones = [
          ...leadData.phones
            .filter(item => item.relationshipType === "Self")
            .map(item => ({
              ...item,
              isPrimary: primaryPhoneType === item.phoneType,
            })),
          ...additionalPhones,
        ];

        const res = await createLead({
          variables: {
            ...leadData,
            emails: allEmails,
            phones: allPhones,
            vehicleOfInterests: sanitizeVehiclesForMutation(leadData.vehiclesOfInterest),
            leadAddressObj: {
              addressLine1: leadData?.addressLine1,
              addressLine2: leadData?.addressLine2,
              city: leadData?.city,
              state: leadData?.state,
              country: leadData?.country,
              postalCode: leadData?.postalCode,
            },
            locationId: value.location,
            leadSourceType: "MANUAL",
          },
        });
        if (res.data.createLead.statusCode === 200) {
          onClose();
          message.success(res.data.createLead.message);
          refetch();
          refetchLeads();
          isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
          refetchLeadOpportunities();
        } else {
          message.error(res.data.createLead.message);
          isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const canAddEditOpportunity = checkAccessPermission(
    AccessPermissionAction.LEAD_OPPORTUNITY_MANAGEMENT_ADD_EDIT
  );

  const [leadSources, setleadSources] = useState([]);
  const { loading: leadSourcesLoader } = useQuery(GET_LEAD_SOURCES_NEW, {
    fetchPolicy: "network-only",
    variables: {
      companyId: user.company.id,
      // locationIds: sessionStorage.getItem("currentLocationId").split(","),
    },
    onCompleted: res => {
      setleadSources(res.getLeadSourcesNew);
    },
  });
  useEffect(() => {
    if (mode === "EDIT") {
      const opprtunity = lead.leadOpportunities[0];
      setselectedOpportunity(opprtunity);
      const vehicleObj = {};
      for (let index = 0; index < opprtunity?.vehiclesOfInterest?.length; index++) {
        const element = opprtunity.vehiclesOfInterest[index];
        for (const key of Object.keys(element)) {
          vehicleObj[`vehiclesOfInterest[${index}].${key}`] = element[key];
        }
      }
      const ownerObj = {};
      for (let index = 0; index < opprtunity?.leadOpportunityUsers?.length; index++) {
        const element = opprtunity.leadOpportunityUsers[index];
        ownerObj[`leadOpportunityUsers-${element.id}`] = element.userId;
      }
      opprtunityForm.setFieldsValue({
        ...opprtunity,
        opportunityName: opprtunity?.name,
        location: opprtunity?.location?.id,
        opportunityTypeId: +opprtunity?.opportunityTypeId,
        opportunitySourceId: getParentIds(leadSources, +opprtunity.opportunitySourceId),
        opportunityStatusId: +opprtunity?.opportunityStatusId,
        // ...vehicleObj,
        ...ownerObj,
      });
    } else {
      form.setFieldsValue({
        location: (sessionStorage.getItem("currentLocationId") || "").includes(",")
          ? null
          : +sessionStorage.getItem("currentLocationId"),
      });
    }
    return () => setselectedOpportunity({ leadOpportunityUsers: [], vehiclesOfInterest: [] });
  }, [lead, mode, leadSources]);
  const [getLeadById] = useLazyQuery(GET_LEAD_DETAIL_CLICK);
  const updateOpportunity = async value => {
    try {
      if (newOpportunity) {
        const payload = {
          ...selectedOpportunity,
          locationId: value.location,
          name: selectedOpportunity.opportunityName,
          vehicleOfInterests: sanitizeVehiclesForMutation(selectedOpportunity.vehiclesOfInterest),
          leadId: lead.id,
        };
        const res = await createLeadOpportunity({
          variables: {
            ...payload,
          },
        });
        if (res.data.createLeadOpportunity.statusCode === 200) {
          message.success(res.data.createLeadOpportunity.message);
          refetchLeads();
          isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
          refetchLeadOpportunities();
        } else {
          message.error(res.data.createLeadOpportunity.message);
        }
      } else {
        const payload = {
          ...selectedOpportunity,
          leadOpportunityId: selectedOpportunity.id,
          locationId: value.location,
          name: selectedOpportunity.opportunityName || selectedOpportunity.name,
          vehicleOfInterests: sanitizeVehiclesForMutation(selectedOpportunity.vehiclesOfInterest),
          leadOpportunityUsers: selectedOpportunity.leadOpportunityUsers.map(item => ({
            id: item.id,
            userId: item.userId,
            userTypeId: item.userTypeId,
          })),
        };
        const res = await updateLeadOpportunity({
          variables: {
            ...payload,
          },
        });
        if (res?.data?.updateLeadOpportunity?.statusCode === 200) {
          message.success(res?.data?.updateLeadOpportunity?.message);
          refetchLeads();
          isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
          refetchLeadOpportunities();
        } else {
          message.error(res?.data?.updateLeadOpportunity?.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const updateLeadHandler = async value => {
    // Collect additional emails and phones from the form
    const additionalEmails = profileForm.collectAdditionalEmails
      ? profileForm.collectAdditionalEmails()
      : [];
    const additionalPhones = profileForm.collectAdditionalPhones
      ? profileForm.collectAdditionalPhones()
      : [];

    // Edge case: primary radio points to a row whose value is empty
    // but other rows have values — block save with a clear message.
    //
    // A missing/NULL `relationshipType` means the contact belongs to the lead
    // themselves — CRM-sourced rows often arrive without it. Matching on
    // === "Self" alone dropped those from `selfPhones`, so the primary lookup
    // below found nothing and the save was blocked with the "primary is empty"
    // error even though the number was right there. Same convention the phone
    // form uses when sorting: `relationshipType || "Self"`.
    const isSelfContact = item => !item?.relationshipType || item.relationshipType === "Self";
    const selfPhones = leadData.phones.filter(isSelfContact);
    const selfEmails = leadData.emails.filter(isSelfContact);

    let primaryPhoneHasValue = false;
    if (phoneArr.includes(primaryPhoneType)) {
      const sp = selfPhones.find(p => p.phoneType === primaryPhoneType);
      primaryPhoneHasValue = !!sp && !!sp.phone && sp.phone.trim() !== "";
    } else if (primaryPhoneType?.startsWith?.("additional_")) {
      const idx = parseInt(primaryPhoneType.replace("additional_", ""), 10);
      const v = profileForm.getFieldValue(`additional_phone_${idx}`);
      primaryPhoneHasValue = !!v && v.trim() !== "";
    }
    // Block the save only when BOTH are true:
    //   a) the row marked primary has no number, AND
    //   b) some other phone row DOES have one.
    // So it is skipped when the primary has a value (the normal case), or when
    // the lead has no phone at all — nothing to be primary, which is allowed.
    const hasPrimaryPhone = primaryPhoneHasValue;
    const hasAnyPhone =
      selfPhones.some(p => p.phone && p.phone.trim() !== "") || additionalPhones.some(p => p.phone);

    if (!hasPrimaryPhone && hasAnyPhone) {
      return message.error(
        "The phone marked as primary is empty. Please enter a value or mark a non-empty phone as primary."
      );
    }

    let primaryEmailHasValue = false;
    if (emailTypes.includes(primaryEmailType)) {
      const se = selfEmails.find(e => e.emailType === primaryEmailType);
      primaryEmailHasValue = !!se && !!se.email && se.email.trim() !== "";
    } else if (primaryEmailType?.startsWith?.("additional_")) {
      const idx = parseInt(primaryEmailType.replace("additional_", ""), 10);
      const v = profileForm.getFieldValue(`additional_email_${idx}`);
      primaryEmailHasValue = !!v && v.trim() !== "";
    }
    // Same rule as the phone check above: only block when a primary is marked
    // but empty AND at least one other email has a value.
    const hasPrimaryEmail = primaryEmailHasValue;
    const hasAnyEmail =
      selfEmails.some(e => e.email && e.email.trim() !== "") || additionalEmails.some(e => e.email);

    if (!hasPrimaryEmail && hasAnyEmail) {
      return message.error(
        "The email marked as primary is empty. Please enter a value or mark a non-empty email as primary."
      );
    }

    // Merge existing emails (with "Self" relation) with additional emails
    const allEmails = [
      ...leadData.emails
        .filter(item => item.relationshipType === "Self")
        .map(item => ({
          ...item,
          isPrimary: primaryEmailType === item.emailType,
        })),
      ...additionalEmails,
    ];

    // Merge existing phones (with "Self" relation) with additional phones
    const allPhones = [
      ...leadData.phones
        .filter(item => item.relationshipType === "Self")
        .map(item => ({
          ...item,
          isPrimary: primaryPhoneType === item.phoneType,
        })),
      ...additionalPhones,
    ];

    const payload = {
      leadId: lead.id,
      ...value,
      leadAddressObj: {
        addressLine1: value.addressLine1,
        addressLine2: value.addressLine2,
        city: value.city,
        state: value.state,
        country: value.country,
        postalCode: value.postalCode,
      },
      emails: allEmails,
      isSyncCheck: true,
      isPushCrm: false,
      phones: allPhones,
    };
    const res = await updateLead({
      variables: payload,
    });

    if (res.data.updateLead.statusCode === 200) {
      message.success(res.data.updateLead.message);

      if (setSelectedLead) {
        try {
          const leadRes = await getLeadById({
            variables: {
              leadId: lead.id,
            },
            fetchPolicy: "network-only",
          });
          if (leadRes?.data?.lead) {
            // Merge through the reducer so the edited lead detail (phones,
            // emails, deletes, etc.) updates the open thread WITHOUT wiping
            // ``messages``. ``getLeadById`` doesn't return messages, and
            // spreading the closure ``selectedLead`` could carry a stale/empty
            // thread — both blanked the conversation after a phone/email edit
            // or delete. mergeLeadDetail runs on current Redux state and keeps
            // messages intact (and no-ops if the open lead is a different one).
            dispatch(mergeLeadDetail(leadRes.data.lead));

            // Update lead list if setLeadList function is provided
            if (setLeadList && leads && leads.length > 0) {
              const arrfn = () => {
                const temp = structuredClone(leads);
                const index = (temp || [])?.findIndex(item => +item.id === +lead.id);

                if (index !== -1) {
                  temp[index] = {
                    ...temp[index],
                    ...leadRes.data.lead,
                  };
                }
                return temp;
              };
              setLeadList(arrfn());
            }
            onClose();
          } else {
            console.error("getLeadById returned no data");
            // Fallback to refetch methods if getLeadById fails
            refetchLeads();
            isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
            refetchLeadOpportunities();
            onClose();
          }
        } catch (error) {
          console.error("Error fetching updated lead data:", error);
          // Fallback to refetch methods if getLeadById fails
          refetchLeads();
          isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
          refetchLeadOpportunities();
          onClose();
        }
      } else {
        refetchLeads();
        isFunction(getLeads) && getLeads({ fetchPolicy: "network-only" });
        refetchLeadOpportunities();
        onClose();
      }
    } else {
      message.error(res.data.updateLead.message);
    }
  };

  // Opportunity Information is only part of lead CREATION. Editing a lead is
  // customer-profile only — opportunities are edited from their own form — so
  // the right-hand panel is never rendered in EDIT mode.
  const showOpportunityPanel = showOpportunityForm && mode === "ADD";

  const mostRecentOpportunity =
    (lead?.leadOpportunities || []).find(
      el => el?.id === lead?.crmLeadObj?.activeLeadOpportunity?.id
    ) || lead?.leadOpportunities?.[0];

  return (
    <div>
      {mode === "ADD" ? (
        <Form form={form} layout="vertical" onFinish={handleSaveLead}>
          <div className="flex flex-row w-full gap-4">
            <div className="w-1/2">
              <LeadCustomerInformationForm
                form={form}
                mode={mode}
                leadData={leadData}
                setleadData={setleadData}
                crmIntegration={crmIntegration}
                primaryPhoneType={primaryPhoneType}
                setprimaryPhoneType={setprimaryPhoneType}
                phoneArr={phoneArr}
                emailTypes={emailTypes}
                primaryEmailType={primaryEmailType}
                setprimaryEmailType={setprimaryEmailType}
              />
            </div>
            {showOpportunityPanel && (
              <>
                <div className=" w-[1px] bg-grey-200" />
                <div className="w-1/2">
                  <LeadOpportunityInformationForm
                    mode={mode}
                    form={form}
                    leadData={leadData}
                    setleadData={setleadData}
                    defaultOpportunity={mostRecentOpportunity}
                    crmIntegration={crmIntegration}
                    leadSources={leadSources}
                    leadSourcesLoader={leadSourcesLoader}
                    canAddEditOpportunity={canAddEditOpportunity}
                  />
                </div>
              </>
            )}
          </div>
          {/* {mode === "ADD" && (
        <div className="bg-grey-200 mt-3 p-6  flex flex-row items-center justify-end gap-1 ">
          <Button onClick={() => onClose}>Cancel</Button>
          <Button loading={createLoader} type="primary" onClick={() => form.submit()}>
            Create Lead
          </Button>
        </div>
      )} */}
        </Form>
      ) : (
        <div className="flex flex-row w-full gap-4">
          <div className={`${showOpportunityPanel ? "w-1/2" : "w-full"}`}>
            <Form form={profileForm} onFinish={updateLeadHandler} layout="vertical">
              <LeadCustomerInformationForm
                mode={mode}
                loader={updateLoader}
                leadData={leadData}
                setleadData={setleadData}
                form={profileForm}
                crmIntegration={crmIntegration}
                primaryPhoneType={primaryPhoneType}
                setprimaryPhoneType={setprimaryPhoneType}
                phoneArr={phoneArr}
                emailTypes={emailTypes}
                primaryEmailType={primaryEmailType}
                setprimaryEmailType={setprimaryEmailType}
              />
            </Form>
          </div>
          {showOpportunityPanel && (
            <>
              <div className=" w-[1px] bg-grey-200" />
              <div className="w-1/2">
                <Form
                  form={opprtunityForm}
                  layout="vertical"
                  onFinish={value => updateOpportunity(value)}
                >
                  <LeadOpportunityInformationForm
                    mode={mode}
                    leadData={leadData}
                    setleadData={setleadData}
                    form={opprtunityForm}
                    lead={lead}
                    loader={updateLeadOpportunityLoader || createLeadOpportunityLoader}
                    selectedOpportunity={selectedOpportunity}
                    setselectedOpportunity={setselectedOpportunity}
                    newOpportunity={newOpportunity}
                    setnewOpportunity={setnewOpportunity}
                    crmIntegration={crmIntegration}
                    defaultOpportunity={lead?.leadOpportunities[0]}
                    leadSources={leadSources}
                    leadSourcesLoader={leadSourcesLoader}
                    canAddEditOpportunity={canAddEditOpportunity}
                  />
                </Form>
              </div>
            </>
          )}
        </div>
      )}
      {/* <div className="flex-row-centered bg-[#F8FAFC] items-center gap-2 p-4 justify-start">
        <Button
          loading={updateLoader || createLoader}
          className="bg-grey-700"
          type="primary"
          onClick={() => {
            mode === "EDIT" ? profileForm.submit() : form.submit();
          }}
        >
          Save
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </div> */}
    </div>
  );
};

export default LeadEditModal;

export const FormField = ({ label, isFieldRequired = false }) => {
  return (
    <label className="mb-1">
      {label}
      {isFieldRequired && <span className="requireFieldStar">*</span>}
    </label>
  );
};
